import { EventCallback } from "../types/EventCallback";

/**
 * Base class for Drag & Drop classes
 */
export abstract class DragDropBase
{
  /** 
   * Returns the enable state, but you have to call enable()/disable() to change (as other things need to happen) 
   * @returns {boolean}
   */
  public get disabled (): boolean 
  { 
    return this._disabled;
  }

  /** 
   * @internal 
   * Internal state for disabled
   */
  protected _disabled: boolean; // initial state to differentiate from false

  /** 
   * @internal 
   * Event register
   */
  protected _eventRegister: {
    [ eventName: string ]: EventCallback;
  } = {};

  /**
   * On Event
   * @param {string} event The event name
   * @param {EventCallback} callback The callback function
   */
  public on (event: string, callback: EventCallback): void
  {
    this._eventRegister[ event ] = callback;
  }

  /**
   * Off Event
   * @param {string} event The event name
   */
  public off (event: string): void
  {
    delete this._eventRegister[ event ];
  }

  /**
   * Enable
   */
  public enable (): void
  {
    this._disabled = false;
  }

  /**
   * Disable
   */
  public disable (): void
  {
    this._disabled = true;
  }

  /**
   * Destroy
   */
  public destroy (): void
  {
    delete this._eventRegister;
  }

  /**
   * Trigger an event
   * @param {string} eventName The event name
   * @param {Event} event The event object
   * @returns {boolean | void}
   */
  public triggerEvent (eventName: string, event: Event): boolean | void
  {
    if (!this.disabled && this._eventRegister && this._eventRegister[ eventName ])
      return this._eventRegister[ eventName ](event);
  }
}
